module.exports = __webpack_public_path__ + "static/img/177.0055295.png";